<script setup lang="ts">
import { FullScreenLoader } from '@/components/LoadingSpinner'
import CreateUserView from '@/components/User/Detail/CreateUserView.vue'
import store from '@/store'
import { EOrganizationActions } from '@/store/organizationStore/OrganizationStoreTypes'
import { EStoreModules } from '@/store/storeType'
import type { OrganizationModel } from '@/types/models/OrganizationModel'
import { defaultUserModel, type UserModel } from '@/types/models/UserModel'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
    ADMIN_ORGANIZATIONS_ROUTES,
    ADMIN_USERS_ROUTES
} from '../../../../router/routing/adminRouting/adminRoutes.js'
import AdminCreateUserOrganization from './components/AdminCreateUserOrganization.vue'

const router = useRouter()
const route = useRoute()

const submitted = ref(false)
const isLoading = ref(false)
const organizationId = ref(route.params.organization_id?.toString())
const userValue = ref<Partial<UserModel>>({ ...defaultUserModel })

const updateUserValue = (value: Partial<UserModel>) =>
    (userValue.value = { ...userValue.value, ...value })

const createUser = () => {
    submitted.value = true
    if (!userValue.value.email || !userValue.value.name) return
    isLoading.value = true
    if (organizationId.value || selectedOrganization.value)
        return store
            .dispatch(`${EStoreModules.ORGANIZATION}/${EOrganizationActions.CREATE_USER}`, {
                organizationId: organizationId?.value ?? selectedOrganization.value?.id,
                userData: userValue.value
            })
            .then(() => {
                submitted.value = false
                organizationId.value
                    ? router.replace(
                          `${ADMIN_ORGANIZATIONS_ROUTES.buildUrl(
                              parseInt(organizationId.value)
                          )}?tab=1`
                      )
                    : router.replace(ADMIN_USERS_ROUTES.baseUrl)
            })
            .finally(() => (isLoading.value = false))
    if (organizationName.value)
        return store
            .dispatch(
                `${EStoreModules.ORGANIZATION}/${EOrganizationActions.INIT_ORGANIZATION_WITH_USER}`,
                {
                    user: userValue.value,
                    organization: {
                        name: organizationName.value
                    }
                }
            )
            .then(res => {
                submitted.value = false
                router.replace(ADMIN_ORGANIZATIONS_ROUTES.buildUrl(res?.organization?.id))
            })
            .finally(() => (isLoading.value = false))
    isLoading.value = false
}

const selectedOrganization = ref<OrganizationModel>()
const organizationName = ref<string>()

const handleChange = (value: string) => {
    if (value) selectedOrganization.value = undefined
    organizationName.value = value
}
const handleSelect = (value: OrganizationModel) => {
    if (value) organizationName.value = undefined
    selectedOrganization.value = value
}
</script>

<template>
    <FullScreenLoader :isLoading="!!isLoading" />
    <CreateUserView
        :data="userValue"
        :submitted="submitted"
        @click="createUser"
        @update="updateUserValue">
        <AdminCreateUserOrganization
            v-if="!organizationId"
            :organizationId="selectedOrganization?.id"
            :organizationName="organizationName"
            @change="handleChange"
            @select="handleSelect" />
    </CreateUserView>
</template>
